<template>
    <div class="pa-0">
         <v-card class="elevation-1 py-12 mt-10">
            <v-row no-gutters justify="center" align="center">
                <v-col cols="6" class="pl-12 pr-2">
                     <h2 data-aos="fade-right" class="b-about-title red-text">
                        Your payment has been cancelled
                    </h2>
                    <b-animating-btn
                        @click="goToCompanyPage"
                        type="submit"
                        text="Go to Company Page"
                        icon="mdiArrowRight"
                        class="mt-6"
                        small
                    ></b-animating-btn>      
                </v-col>
                <v-col cols="5">
                    <v-img
                        src="@/assets/register-image.png"
                        width="300"
                        class="mx-auto"
                    ></v-img>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "ErrorMessage",

    data() {
        return {
            
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        }
    },

    methods: {
        ...mapActions("loyaltyPanel", ["changePaymentStatus"]),

       goToCompanyPage(){
           this.$router.push(`/en/loyaltyPanel`)
       }
    },

    mounted() {
        let body = {
            status: "cancel",
            sid: this.$route.query.sid
        }
        this.changePaymentStatus(body)
    }
};
</script>
<style lang="scss" scoped>
    .red-text{
        color: red !important;
    }
</style>
